<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 년도 -->
          <c-datepicker
            :range="true"
            type="year"
            default="today"
            label="LBLYEAR"
            name="years"
            v-model="searchParam.years"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            type="search"
            stepperGrpCd="HEA_INVESTIGATION_STEP_CD"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="heaInvestigationStepCd"
            label="LBLSTEPPROGRESS"
            v-model="searchParam.heaInvestigationStepCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      title="근골격계 조사계획 목록"
      tableId="lawMakingCheck"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!-- 등록 -->
          <c-btn v-if="editable" label="LBLREG" icon="add" @btnClicked="openPop" /> 
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'investigationPlan',
  data() {
    return {
      searchParam: {
        plantCd: null,
        years: [],
        heaInvestigationStepCd: null,
      },
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            sortable: false,
            style: 'width:100px',
          },
          {
            name: 'investigationPlanName',
            field: 'investigationPlanName',
            label: '조사계획명',
            align: 'left',
            sortable: false,
            style: 'width:300px',
            type: 'link'
          },
          {
            name: 'year',
            field: 'year',
            label: 'LBLYEAR',
            align: 'center',
            sortable: false,
            style: 'width:120px',
          },
          {
            name: 'investigationPeriod',
            field: 'investigationPeriod',
            label: '조사기간',
            align: 'center',
            sortable: false,
            style: 'width:180px',
          },
          {
            name: 'userName',
            field: 'userName',
            label: 'LBLMANAGER',
            align: 'center',
            sortable: false,
            style: 'width:120px',
          },
          {
            name: 'investigationDeptName',
            field: 'investigationDeptName',
            label: '조사부서',
            align: 'center',
            sortable: false,
            style: 'width:250px',
          },
          {
            name: 'heaInvestigationStepName',
            field: 'heaInvestigationStepName',
            label: 'LBLSTEPPROGRESS',
            align: 'center',
            sortable: false,
            style: 'width:100px',
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.hea.muscleSystem.investigationPlan.list.url
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
      // this.grid.data = [
      //   {
      //     plantName: '사업장1',
      //     name: '2022년 상반기 근골격계 조사 (생산팀)',
      //     year: '2022',
      //     period: '2022-01-02 ~ 2022-06-30',
      //     managerName: '관리자',
      //     deptNames: '생산팀, 생산팀A, 생산팀B',
      //   }
      // ]
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col) {
      this.openPop(row)
    },
    openPop(row) {
      this.popupOptions.title = '근골격계 조사계획';
      this.popupOptions.param = {
        heaInvestigationPlanId: row ? row.heaInvestigationPlanId : '',
      };
      this.popupOptions.target = () => import(`${'./investigationPlanDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
